module.exports = __webpack_public_path__ + "img/mapping_setting.2a57f0f7.svg";